<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Allocate Users</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <form autocomplete="off">
    <div class="row">

      <div class="col-6 mb-3" *ngIf="paralegalUsers.length">
        <label class="form-label">Paralegal</label>
        <ng-select
          [items]="paralegalUsers"
          bindLabel="name"
          placeholder="Search paralegal..."
          [(ngModel)]="selectedParalegal"
          [ngModelOptions]="{standalone: true}"
          (change)="selectionUpdated()">
        </ng-select>
      </div>

      <div class="col-6 mb-3" *ngIf="adminUsers.length">
        <label class="form-label">Admin</label>
        <ng-select
          [items]="adminUsers"
          bindLabel="name"
          placeholder="Search admin..."
          [(ngModel)]="selectedAdmin"
          [ngModelOptions]="{standalone: true}"
          (change)="selectionUpdated()">
        </ng-select>
      </div>

    </div>
  </form>
</div>

<div class="modal-footer">
  <ng-container *ngIf="!isLoading">
    <button type="button" class="btn btn-success" [disabled]="invalidSelection" (click)="allocateCase()">Save</button>
  </ng-container>

  <button *ngIf="isLoading" type="button" class="btn btn-success" disabled>
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    Saving...
  </button>
</div>